import { CodeSystem } from "context/elasticsearch/types";
import { type DOMNode, domToReact, Element } from "html-react-parser";
import { Link } from "react-router-dom";

/*  
		- Replaces the a-tag with a Link from react-router-dom
		- Replaces the href with the correct path	
*/

const replaceLink = (
  domNode: Element,
  codeSystem: CodeSystem,
  onClick?: () => void
) => {
  if (
    codeSystem === CodeSystem.Icpc2 &&
    domNode instanceof Element &&
    domNode.attribs.href
  ) {
    const removeHashTagandLink = domNode.attribs?.href
      ?.replaceAll("#", `/${CodeSystem.Icpc2}/chapter/`)
      .replaceAll(
        "/codesystem/ICD-10/concept/",
        `/${CodeSystem.Icd10}/chapter/`
      );

    return (
      <Link
        to={`${removeHashTagandLink}`}
        onClick={onClick}
        className="text-decoration-none"
      >
        {domToReact(domNode.children as DOMNode[])}
      </Link>
    );
  } else if (domNode instanceof Element && domNode.attribs?.href) {
    // Some warning occurs here for weird links for aktuelle sverdkoder, see ICD-10 code M36.0 for example, replacing the found link to healthterm, not sure if it covers all cases
    const removeHashTag = domNode.attribs.href
      .replaceAll("#", "")
      .replaceAll(
        "https://healthterm.ehelse.no/EditingInbox.do?method=showInbox",
        ""
      );
    return (
      <Link
        to={`/${codeSystem}/chapter/${removeHashTag}`}
        className="text-decoration-none"
      >
        {domToReact(domNode.children as Element[])}
      </Link>
    );
  }
};

export default replaceLink;
